import type { MetaFunction } from "react-router";

import { mdxComponents } from "@/ui/mdx-components";

import {
  Frontmatter,
  LegalContactDetails,
  type LegalFrontmatter,
} from "./frontmatter";
import MDXContent, { frontmatter } from "./terms.mdx";

export const meta: MetaFunction = () => {
  const legalFrontmatter = frontmatter as LegalFrontmatter;
  return [{ title: `${legalFrontmatter.title} | ${publicEnv.siteTitle}` }];
};

export default function Terms() {
  const legalFrontmatter = frontmatter as LegalFrontmatter;

  return (
    <article>
      <Frontmatter frontmatter={legalFrontmatter} />
      <MDXContent components={{ ...mdxComponents, LegalContactDetails }} />
    </article>
  );
}
